import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useStore } from '@shared/hooks/use-store.hook'
import { Actions } from '@shared/lib/reducer'

const getPathBase = (path: string) => {
  const splittedPath = path.split('/')
  const filteredPaths = splittedPath.filter((el) => el)
  return filteredPaths[0]
}

interface UpdaterProps {
  children?: React.ReactNode
}

const Updater: React.FC<UpdaterProps> = ({ children }) => {
  const location = useLocation()
  const { dispatch } = useStore()
  const prevPathnameRef = React.useRef<string>(location.pathname)

  useEffect(() => {
    const currentPathname = location.pathname
    const prevPathname = prevPathnameRef.current

    const prevPathBase = getPathBase(prevPathname)
    const currentPathBase = getPathBase(currentPathname)
    const isPrevPathBaseAudit = prevPathBase === 'audit'

    if (prevPathname !== currentPathname) {
      dispatch({
        type: Actions.UPDATE_PATHS,
        payload: { currentPathBase, prevPathBase },
      })

      if (isPrevPathBaseAudit && prevPathBase !== currentPathBase) {
        dispatch({ type: Actions.CLEAR_EXPANDED_VALUES })
      }
    }

    prevPathnameRef.current = currentPathname
  }, [location.pathname, dispatch])

  return <>{children}</>
}

export const UpdateHandler: React.FC<UpdaterProps> = ({ children }) => {
  return <Updater>{children}</Updater>
}
